import { OPERATORS, TYPES } from '../../../common/list-utils';
import { IChoiceGroupOption, IComboBoxOption, IDropdownOption } from '@fluentui/react';

export class ListColumnFilter /* extends ListColumn */ {
  name: string;
  quick?: boolean;
  type: string;
  operator: string;
  placeholder?: string;
  contextForDropdown?: IDropdownOption<any>[];
  contextForCombobox?: IComboBoxOption[];
  contextForRadio?: IChoiceGroupOption[];
  labelForCheckbox?: string;
  checkBoxValue?: string;
  grow?: number;
  defaultValue?: string;
  hidden?: boolean;
  disabled?: boolean;
  example?: string;

  constructor(
    type: string = TYPES.INPUT,
    operator: string = OPERATORS.CONTAINS,
    name: string,
    prop: string,
    grow: number,
    defaultValue?: string | null,
    hidden?: boolean | null,
    disabled?: boolean | null,
    example?: string | null
  ) {
    this.type = type;
    if (type === TYPES.CHECKBOX) {
      this.labelForCheckbox = name;
      this.checkBoxValue = '1';
    }
    this.name = prop;
    this.operator = operator;
    this.placeholder = name;
    this.grow = grow;
    this.defaultValue = defaultValue ? defaultValue : '';
    this.hidden = hidden ? hidden : false;
    this.disabled = disabled ? disabled : false;
    this.example = example ? example : '';
  }
}

// export const getFiltersConfig = (listColums: ListColumn<any>[]) => {
export const getFiltersConfig = (listColums: any) => {
  let _filtersConfig: any[] = [];
  listColums.forEach((col: any) => {
    if (col) {
      _filtersConfig.push(col);
    }
  });

  return _filtersConfig;
};
